import PropTypes from '~/lib/propTypes'
import styled from '@emotion/styled'
import { space, Alert, color } from '@ticketswap/solar'
import { createMarkup } from '~/utils/createMarkup'

const Container = styled.div`
  position: relative;
  margin-block-start: ${space[16]};
`

const AnnouncementAlert = styled(Alert)`
  background-color: #1a212999;
`

const AnnouncementText = styled.span`
  color: ${color.lightForeground};

  a {
    color: ${color.lightForeground};
  }
`

const HomepageAnnouncement = ({ announcement }) => {
  if (!announcement || announcement.length <= 1) return null

  return (
    <Container>
      <AnnouncementAlert variant="info">
        <AnnouncementText
          dangerouslySetInnerHTML={createMarkup(announcement, {
            renderInline: true,
          })}
        />
      </AnnouncementAlert>
    </Container>
  )
}

HomepageAnnouncement.propTypes = {
  announcement: PropTypes.string,
}

export default HomepageAnnouncement
